/* MR. OFFICIAL — theme interactions */
(function () {
  'use strict';
  var d = document;
  var w = window;
  w.moBooted = true;
  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var routes = w.moRoutes || { cartAdd: '/cart/add', cart: '/cart', root: '/' };

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function bound(el, key) { key = key || 'moBound'; if (el.dataset[key]) return true; el.dataset[key] = '1'; return false; }
  function markNav() { try { w.sessionStorage.setItem('mo-nav', '1'); } catch (e) {} }

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = w.moMoneyFormat || '${{amount}}';
    var whole = cents % 100 === 0;
    var n = (cents / 100).toFixed(whole ? 0 : 2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_with_comma_separator') return n.replace('.', ',');
      if (key === 'amount_no_decimals') return parts[0];
      return parts.join('.');
    });
  }

  /* ---------- Reveal (only when motion is active; otherwise content is already visible) ---------- */
  var motion = d.documentElement.classList.contains('mo-motion');
  var io = (motion && 'IntersectionObserver' in w) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;

  function initReveal(root) {
    $$('.mo-reveal:not(.is-visible)', root).forEach(function (el) {
      if (io) { io.observe(el); } else { el.classList.add('is-visible'); }
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var h = $('[data-mo-header]');
    if (!h) return;
    var ticking = false;
    function update() { h.classList.toggle('is-scrolled', w.scrollY > 40); ticking = false; }
    update();
    w.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; w.requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- Overlays (open only on user action) ---------- */
  var lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = d.activeElement;
    el.hidden = false;
    w.requestAnimationFrame(function () {
      el.classList.add('is-open');
      var focusable = $('input[type="search"], input[type="email"], [data-mo-close]', el);
      if (focusable) focusable.focus();
    });
    d.body.classList.add('mo-lock');
    $$('[data-mo-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    d.body.classList.remove('mo-lock');
    $$('[data-mo-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 500);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  d.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-mo-open]') : null;
    if (opener) { e.preventDefault(); openOverlay(d.getElementById(opener.getAttribute('data-mo-open'))); return; }
    var closer = e.target.closest ? e.target.closest('[data-mo-close]') : null;
    if (closer) { e.preventDefault(); closeOverlay(closer.closest('.mo-overlay')); }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { $$('.mo-overlay.is-open').forEach(closeOverlay); }
  });
  /* Never leave the page locked if an overlay is restored from the back/forward cache */
  w.addEventListener('pageshow', function () {
    $$('.mo-overlay').forEach(function (el) { el.classList.remove('is-open'); el.hidden = true; });
    d.body.classList.remove('mo-lock');
  });

  /* ---------- Page transitions (with failsafe so a page can never stay blank) ---------- */
  function initTransitions() {
    if (reduce || (w.Shopify && w.Shopify.designMode)) return;
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(href)) return;
      var url;
      try { url = new URL(a.href, w.location.href); } catch (err) { return; }
      if (url.origin !== w.location.origin) return;
      if (url.pathname === w.location.pathname && url.search === w.location.search) return;
      if (/\/(checkout|checkouts|cart\/|account\/logout|apps\/)/.test(url.pathname)) return;
      e.preventDefault();
      markNav();
      d.documentElement.classList.add('mo-leaving');
      setTimeout(function () { w.location.href = url.href; }, 280);
      setTimeout(function () { d.documentElement.classList.remove('mo-leaving'); }, 4000);
    });
    w.addEventListener('pageshow', function (e) {
      if (e.persisted) d.documentElement.classList.remove('mo-leaving');
    });
  }

  /* ---------- Cart ---------- */
  function updateBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = d.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var tmp = d.createElement('div');
    tmp.innerHTML = sections['cart-icon-bubble'];
    var inner = tmp.querySelector('.shopify-section');
    bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
  }

  var toastEl = null;
  var toastTimer = null;
  function toast(message, withLink) {
    if (!toastEl) {
      toastEl = d.createElement('div');
      toastEl.className = 'mo-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      d.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = d.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (withLink) {
      var link = d.createElement('a');
      link.href = routes.cart;
      link.textContent = 'View Cart';
      toastEl.appendChild(link);
    }
    w.requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4200);
  }

  function addToCart(items) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: w.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw data;
        return data;
      });
    }).then(function (data) {
      updateBubble(data.sections);
      try { d.dispatchEvent(new CustomEvent('mo:cart:added', { detail: data })); } catch (e) {}
      return data;
    });
  }

  function errorText(err) {
    return (err && (err.description || err.message)) || 'Sorry, this item could not be added.';
  }

  /* ---------- Quick add ---------- */
  function initQuick(root) {
    $$('[data-mo-quick] button[data-variant-id]', root).forEach(function (btn) {
      if (bound(btn)) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var wrap = btn.closest('[data-mo-quick]');
        wrap.classList.add('is-loading');
        addToCart([{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }])
          .then(function () { toast((wrap.getAttribute('data-title') || 'Item') + ' added to your cart', true); })
          .catch(function (err) { toast(errorText(err), false); })
          .then(function () { wrap.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Lightbox ---------- */
  var lb = null;
  function lightbox(srcs, index) {
    if (!srcs.length) return;
    if (!lb) {
      lb = d.createElement('div');
      lb.className = 'mo-overlay mo-lightbox';
      lb.id = 'MoLightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Image viewer');
      lb.hidden = true;
      lb.innerHTML = '<button type="button" class="mo-overlay-close" data-mo-close>Close</button>' +
        '<button type="button" class="mo-lightbox__prev" aria-label="Previous image">Prev</button>' +
        '<img alt="">' +
        '<button type="button" class="mo-lightbox__next" aria-label="Next image">Next</button>';
      d.body.appendChild(lb);
      var img = $('img', lb);
      lb._show = function () { img.src = lb._srcs[lb._i]; };
      lb._step = function (n) { lb._i = (lb._i + n + lb._srcs.length) % lb._srcs.length; lb._show(); };
      $('.mo-lightbox__prev', lb).addEventListener('click', function () { lb._step(-1); });
      $('.mo-lightbox__next', lb).addEventListener('click', function () { lb._step(1); });
      img.addEventListener('click', function () { closeOverlay(lb); });
      d.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') lb._step(-1);
        if (e.key === 'ArrowRight') lb._step(1);
      });
    }
    lb._srcs = srcs;
    lb._i = index || 0;
    var single = srcs.length < 2;
    $('.mo-lightbox__prev', lb).hidden = single;
    $('.mo-lightbox__next', lb).hidden = single;
    lb._show();
    openOverlay(lb);
  }

  /* ---------- Product page ---------- */
  function showMedia(scope, id) {
    if (!id) return;
    var slides = $$('[data-media-id]', scope);
    var target = null;
    slides.forEach(function (s) { if (String(s.getAttribute('data-media-id')) === String(id)) target = s; });
    if (!target) return;
    slides.forEach(function (s) { s.classList.toggle('is-active', s === target); });
    $$('[data-mo-thumb]', scope).forEach(function (t) {
      var on = String(t.getAttribute('data-mo-thumb')) === String(id);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
    var stage = $('.mo-pdp__stage', scope);
    if (stage && w.matchMedia('(max-width: 989px)').matches && stage.scrollTo) {
      stage.scrollTo({ left: target.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  function initProduct(root) {
    $$('[data-mo-product]', root).forEach(function (el) {
      if (bound(el)) return;

      $$('[data-mo-thumb]', el).forEach(function (t) {
        t.addEventListener('click', function () { showMedia(el, t.getAttribute('data-mo-thumb')); });
      });
      var zooms = $$('[data-mo-zoom]', el);
      zooms.forEach(function (z, i) {
        z.addEventListener('click', function () {
          lightbox(zooms.map(function (x) { return x.getAttribute('data-mo-zoom'); }), i);
        });
      });

      var jsonEl = $('[data-mo-product-json]', el);
      var form = $('form.mo-pdp__form', el);
      if (!jsonEl || !form) return;
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var btn = $('[data-mo-add]', form);
      var msg = $('[data-mo-msg]', form);
      var priceEl = $('[data-mo-price]', el);
      var cmpEl = $('[data-mo-compare]', el);
      var saveEl = $('[data-mo-save]', el);
      var groups = $$('[data-mo-option-group]', el);
      if (!idInput || !qtyInput || !btn) return;

      function current() {
        return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
      }
      function find(opts) {
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i];
          var ok = true;
          for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function update(push) {
        var opts = current();
        var v = groups.length ? find(opts) : data.variants[0];
        groups.forEach(function (g, gi) {
          var out = g.querySelector('[data-mo-opt-value]');
          if (out) out.textContent = opts[gi] || '';
          $$('input', g).forEach(function (inp) {
            var test = opts.slice();
            test[gi] = inp.value;
            var tv = find(test);
            var pill = inp.closest('.mo-opt__pill');
            if (pill) pill.classList.toggle('is-unavailable', !tv || !tv.available);
          });
        });
        if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold Out';
        if (priceEl) priceEl.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (cmpEl) { cmpEl.hidden = !onSale; if (onSale) cmpEl.textContent = money(v.compare_at_price); }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
        if (v.featured_media && v.featured_media.id) showMedia(el, v.featured_media.id);
        if (push && w.history.replaceState) {
          try {
            var u = new URL(w.location.href);
            u.searchParams.set('variant', v.id);
            w.history.replaceState({}, '', u.toString());
          } catch (e) {}
        }
      }

      groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
      $$('[data-mo-qty]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-mo-qty'), 10);
          qtyInput.value = Math.max(1, n);
        });
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        btn.classList.add('is-loading');
        btn.disabled = true;
        if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
        addToCart([{ id: parseInt(idInput.value, 10), quantity: q }])
          .then(function () {
            if (msg) msg.textContent = 'Added to your cart.';
            toast(data.title + ' added to your cart', true);
          })
          .catch(function (err) {
            if (msg) { msg.classList.add('is-error'); msg.textContent = errorText(err); }
          })
          .then(function () {
            btn.classList.remove('is-loading');
            update(false);
          });
      });
      update(false);
    });
  }

  /* ---------- Shop: sort + infinite loading ---------- */
  function initShop(root) {
    $$('[data-mo-sort]', root).forEach(function (sel) {
      if (bound(sel)) return;
      sel.addEventListener('change', function () {
        var u = new URL(w.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        markNav();
        w.location.href = u.toString();
      });
    });
    $$('[data-mo-more]', root).forEach(function (more) {
      if (bound(more)) return;
      var shop = more.closest('[data-mo-shop]');
      var grid = shop ? $('[data-mo-grid]', shop) : null;
      if (!grid) return;
      var loading = false;
      var obs = null;
      function load() {
        var href = more.getAttribute('href');
        if (loading || !href) return;
        loading = true;
        more.classList.add('is-loading');
        more.textContent = 'Loading';
        fetch(href).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-mo-grid]');
          var nextMore = doc.querySelector('[data-mo-more]');
          if (nextGrid) {
            Array.prototype.slice.call(nextGrid.children).forEach(function (c) { grid.appendChild(d.importNode(c, true)); });
            initReveal(grid);
            initQuick(grid);
          }
          if (nextMore) {
            more.setAttribute('href', nextMore.getAttribute('href'));
            more.textContent = 'Load More';
          } else {
            if (obs) obs.disconnect();
            var wrap = more.parentNode;
            if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
          }
        }).catch(function () {
          more.textContent = 'Load More';
        }).then(function () {
          loading = false;
          more.classList.remove('is-loading');
        });
      }
      more.addEventListener('click', function (e) { e.preventDefault(); load(); });
      if ('IntersectionObserver' in w) {
        obs = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) load(); }, { rootMargin: '600px 0px' });
        obs.observe(more);
      }
    });
  }

  /* ---------- Horizontal rails ---------- */
  function initRails(root) {
    $$('[data-mo-rail-wrap]', root).forEach(function (wrap) {
      if (bound(wrap)) return;
      var rail = $('[data-mo-rail]', wrap);
      if (!rail) return;
      $$('[data-mo-rail-dir]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: parseInt(b.getAttribute('data-mo-rail-dir'), 10) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs(root) {
    $$('[data-mo-recs]', root).forEach(function (el) {
      if (bound(el)) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = d.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-mo-recs]');
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
          initQuick(el);
        } else {
          el.hidden = true;
        }
      }).catch(function () { el.hidden = true; });
    });
  }

  /* ---------- Boot (each module isolated so one failure never blocks the rest) ---------- */
  function safe(fn, arg) { try { fn(arg); } catch (e) { if (w.console && console.warn) console.warn('[MR. OFFICIAL]', e); } }
  function initAll(root) {
    safe(initReveal, root);
    safe(initQuick, root);
    safe(initProduct, root);
    safe(initShop, root);
    safe(initRails, root);
    safe(initRecs, root);
  }
  function boot() {
    safe(initHeader);
    safe(initTransitions);
    initAll(d);
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
